import review1 from "public/customer-testimonials/review1.png";
import review2 from "public/customer-testimonials/review2.png";
import review3 from "public/customer-testimonials/review3.png";
import review4 from "public/customer-testimonials/review4.png";
import review1_Bg from "public/customer-testimonials/review1_Bg.png";
import review2_Bg from "public/customer-testimonials/review2_Bg.png";
import review3_Bg from "public/customer-testimonials/review3_Bg.png";
import review4_Bg from "public/customer-testimonials/review4_Bg.png";

export const SUCCESS_COMP = {
  Heading: "Customer Success with OneMind Services",
  Description:
    "Discover how businesses have transformed with OneMind Services. From small startups to large enterprises, our customized solutions have empowered organizations to achieve their goals with security and confidence. Explore their journeys and see how we can create success for you too.",
};

export const CLIENTS_REVIEW = {
  HEADING: "What Our Customers Say About Us",
  DESCRIPTION:
    "Here's how our innovative solutions and dedicated support have transformed their businesses and empowered them to thrive.",
  CONTENT: [
    {
      image: review1,
      bg_image: review1_Bg,
      title: "Unified Observability Boosts Efficiency for a Global Fast-Food Chain",
      description: {
        challenge:
          "A leading global fast-food chain was facing an uphill battle against operational inefficiencies. Disconnected monitoring systems left blind spots in their network, delaying issue detection and resolution. With the clock ticking during peak service hours, it risked slowing operations and impacting the customer experience.",
        results: [
          {
            title: "",
            desc: "The impact was immediate and far-reaching:",
          },
          {
            title: "Faster Resolutions: ",
            desc: "Event correlation efficiency cut resolution times by 40%, keeping restaurants operational even during high-demand hours.",
          },
          {
            title: "Cost Efficiency: ",
            desc: "Consolidating monitoring tools slashed unnecessary expenses, creating significant cost savings.",
          },
          {
            title: "Future-Ready Growth: ",
            desc: "The system’s scalability allowed the chain to confidently expand into new markets without skipping a beat.",
          },
          {
            title: "Operational Reliability",
            desc: "Improved network visibility ensured higher application uptime, enhancing the reliability of restaurant operations.",
          },
        ],
        solutions: [
          {
            title: "",
            desc: "Determined to regain control, the company adopted a game-changing unified observability approach. This transformative system introduced:",
          },
          {
            title: "Centralized Monitoring Tools: ",
            desc: "Real-time Network Management Systems (NMS) and Security Information and Event Management (SIEM) tools brought all critical data under one roof.",
          },
          {
            title: "Custom Dashboards for All Teams: ",
            desc: "Executives, engineers, and operations teams gained tailored views of actionable insights for swift decision-making.",
          },
          {
            title: "Seamless Integration: ",
            desc: "The observability platform harmonized wireless, network, and security systems, paving the way for streamlined IT operations.",
          },
        ],
      },
      slug: "/case-studies/unified-Observability",
    },
    {
      image: review2,
      bg_image: review2_Bg,
      title: "Revitalizing a Credit Union: Strengthening Security and Scaling for Growth",
      description: {
        challenge:
          "Faced with outdated technology and security vulnerabilities, a credit union needed to reclaim control, fortify its infrastructure, and prepare for a secure, scalable future.",
        results: [
          {
            title: "",
            desc: "In just 72 hours, critical systems were back online.",
          },
          {
            title: "",
            desc: "Within six months, the credit union met all compliance requirements.",
          },
          {
            title: "",
            desc: "A decade of neglected technology was overhauled, leaving the organization with a modern, secure, and scalable IT foundation.",
          },
          {
            title: "",
            desc: "Today, the credit union stands stronger than ever, with the confidence to serve its members and face the future without fear.",
          },
        ],
        solutions: [
          {
            label: "Step 1: Reclaiming Control",
            title: "",
            desc: "The first step was regaining administrative access to critical systems. Piece by piece, firewalls,  and Active Directory were restored, putting the organization back in charge of its operations.",
          },
          {
            label: "Step 2: Reinventing Infrastructure",
            title: "",
            desc: "Modern firewalls were installed to fortify defenses. Advanced EDR/XDR/MDR tools were deployed to ensure round-the-clock security and endpoint protection.",
          },
          {
            label: "Step 3: Future-Proofing Operations",
            title: "",
            desc: "With workloads migrated to OneMind Cloud, the credit union gained a scalable, secure environment for its operations. A robust DRaaS solution was implemented, ensuring they could recover quickly in the face of any disaster.",
          },
        ],
      },
      slug: "/case-studies/revitalizing-a-Credit-Union",
    },
    {
      image: review3,
      bg_image: review3_Bg,
      title: "Accelerating Innovation with Custom Proof-of-Concept Testing Labs ",
      description: {
        challenge:
          "The clock was ticking for a global technology company. Their reputation depended on seamless network automation, but hidden bugs in device drivers threatened to disrupt operations for enterprise customers. They needed a solution—not tomorrow, but today.",
        results: [
          {
            title: "",
            desc: "Faster, safer deployments.",
          },
          {
            title: "",
            desc: "Happy customers.",
          },
          {
            title: "",
            desc: "And a business that’s not just staying ahead of the curve but defining it.",
          },
        ],
        solutions: [
          {
            title: "",
            desc: "Enter the bug-catcher, aka a hosted proof-of-concept lab:",
          },
          {
            title: "",
            desc: "A state-of-the-art hosted lab was deployed, engineered to supercharge their validation process. With precision tools and innovative workflows, the lab became a fortress against undetected software flaws.",
          },
          {
            title: "",
            desc: "In less than six months, the impossible happened. A critical bug—one that could have jeopardized enterprise networks—was caught just in time. But the story doesn’t end there. Seeing the success, the company doubled down, commissioning a second lab. This time, it wasn’t just for testing—it was a showcase, wowing potential customers and turning prospects into partners.",
          },
        ],
      },
      slug: "/case-studies/accelerating-innovation",
    },
    {
      image: review4,
      bg_image: review4_Bg,
      title:
        "Reclaiming Control: Empowering Labor Operations with Scalable Cloud Solutions",
      description: {
        challenge:
          "A major labor union faced a critical impasse when their software vendor demanded a steep 30% hike in annual fees, amounting to $4 million per year. The vendor's claim to maintain the software’s functionality was vital for processing member benefits, jobs, and services. With no documentation or visibility into the codebase, the union’s dependence on the vendor left their operations vulnerable. Adding urgency, a four-week deadline was set to transition the system, threatening to disrupt services for thousands of members.",

        results: [
          {
            title: "",
            desc: "The labor union reclaimed full control of its software, achieving annual savings of $2 million by eliminating vendor lock-in. The new cloud-based infrastructure improved system scalability, performance, and security. With a fully documented and maintainable system, the union now operates autonomously, safeguarding member services while reducing operational costs.",
          },
        ],
        solutions: [
          {
            title: "",
            desc: "We reverse-engineered the proprietary software, unlocking the code to ensure operational continuity. The team swiftly migrated the union’s entire software stack to a secure cloud environment, including dependencies such as payment gateways and Kubernetes workloads. Modern engineering practices, including CI/CD pipelines, were implemented to boost performance. The migration was executed seamlessly, avoiding downtime and ensuring resilience under intense time constraints.",
          },
        ],
      },

      slug: "/case-studies/reclaiming-control",
    },
  ],
};
